import React from "react";

import OrganizationDetails from "../components/OrganizationDetails/OrganizationDetails";

const OrganizationDetailsPage = () => {
  return <OrganizationDetails />;
};

export default OrganizationDetailsPage;
